/**
 * Хуки данных витрины каталога услуг (Tanstack Query поверх @hsc/api-client).
 *
 * Backend GET /v1/service-catalog — фаза 3 (параллельно); до выката
 * endpoint'а хуки работают против MSW-моков в тестах.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createServiceRequest, getServiceCatalog } from '@hsc/api-client';
import type {
  CatalogViewResponse,
  ServiceRequestCreateInput,
  ServiceRequestCreatedResponse,
} from '@hsc/types';

export function useServiceCatalog(locale: string) {
  return useQuery<CatalogViewResponse>({
    queryKey: ['service-catalog', locale],
    queryFn: () => getServiceCatalog(locale),
  });
}

export function useCreateServiceRequest() {
  const queryClient = useQueryClient();
  return useMutation<ServiceRequestCreatedResponse, Error, ServiceRequestCreateInput>({
    mutationFn: createServiceRequest,
    onSuccess: () => {
      // Список заявок гостя (когда появится) должен перезагрузиться.
      void queryClient.invalidateQueries({ queryKey: ['requests'] });
    },
  });
}
